/**
 * User Role Enum
 */
export const USER_ROLES = {
	COACH: 'coach',
	STUDENT: 'end-user-client',
};
